export default {
  install (Vue) {
    Vue.mixin({
      data () {
        // 判断是否在pwa中
        const isInStandaloneMode = () =>
          window.matchMedia('(display-mode: standalone)').matches ||
          window.navigator.standalone ||
          document.referrer.includes('android-app://')

        var userAgent = navigator.userAgent
        var isTikTok = false
        // aweme-国内版抖音
        if (userAgent.includes('BytedanceWebview') || userAgent.includes('ByteLocale') || userAgent.includes('aweme')) {
          isTikTok = true
        }
        var isFaceBook = false
        if (userAgent.includes('FBAN') || userAgent.includes('FBAV')) {
          isFaceBook = true
        }
        // 判断是否在safari
        function detectIOSBrowser () {
          // 检查是否在iOS设备上
          // const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

          // 检测是否是Safari
          const isSafari = () => {
            const ua = navigator.userAgent
            const vendor = navigator.vendor
            return /Safari/i.test(ua) && /Apple Computer/.test(vendor) && !/CriOS|FxiOS|OPiOS|mercury/i.test(ua)
          }

          // 检测是否是Chrome
          const isChrome = () => /CriOS/i.test(navigator.userAgent)

          // 检测是否是Firefox
          const isFirefox = () => /FxiOS/i.test(navigator.userAgent)

          // 检测是否是Opera
          const isOpera = () => /OPiOS/i.test(navigator.userAgent)
          if (isFaceBook || isTikTok) {
            return false
          }
          if (isSafari()) {
            return true
          } else if (isChrome()) {
            return false
          } else if (isFirefox()) {
            return false
          } else if (isOpera()) {
            return false
          } else {
            return false
          }
        }
        return {
          isTikTok,
          isFaceBook,
          isOpenApp: isInStandaloneMode(),
          isInSafari: detectIOSBrowser()
        }
      }
    })
  }
}
